
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, prepareUploadFileData, sendToUploadFileApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";

const UserNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [promoteToAdmin, setPromoteToAdmin] = useState(false);
    const [blockUser, setBlockUser] = useState(false);
    const [entityData, setEntityData] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        firstName: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.firstName')),
        lastName: Yup.string()
            .min(3, t("validation.min.generic", { field: t('name'), qty: 3 }))
            .required(t('validation.required.lastName')),
        email: Yup.string().required(t('validation.required.email')),
        password: Yup.string().required(t('validation.required.password')),
        passwordConfirmation: Yup.string().required(t('validation.required.password')),
        group: Yup.object().nullable().optional()
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordConfirmation: '',
            blockUser: false,
            promoteToAdmin: false,
            group: null,
            branches: []
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let group = null;
            if(values.group !== null) {
                group = {
                    id: values.group.value
                }
            }

            let branches = [];
            values.branches.forEach((item) => {
                branches.push({
                    id: item.value
                });
            });

            let payload = {
                id: getId(entityData),
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                password: entityData != null && values.password === "**********" ? null : values.password,
                active: true,
                blocked: blockUser,
                admin: promoteToAdmin,
                status: convertBooleanToStatus(status),
                group: group,
                branches: branches,
                photo: uploadedFile !== null ? (entityData?.photo ?? null) : null
            }

            prepareUploadFileData(uploadedFile, payload, "user", entityData).then(data => {
                sendToUploadFileApi(Api.identity.user + "/upload", data, payload.id, () => {
                    if (entityData == null) {
                        onReset();
                    } else {
                        navigate(MenuConfig.identity.user.route);
                    }
                }, (error) => {
                    ApiError(error);
                    formik.setSubmitting(false);
                });
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    const onReset = () => {
        formik.resetForm();
        setStatus(true);
        setPromoteToAdmin(false);
        setBlockUser(false);
        setUploadedFile(null);
    }

    return (
        <>
            <NewPage
                motherMenu={t('identity')}
                childMenu={t('users')}
                activeMenu={t('new')}
                child={
                    <Form formik={formik} status={status} setStatus={setStatus}
                        entityData={entityData}
                        promoteToAdmin={promoteToAdmin}
                        blockUser={blockUser}
                        setBlockUser={setBlockUser}
                        setPromoteToAdmin={setPromoteToAdmin}
                        setUploadedFile={setUploadedFile}
                        uploadedFile={uploadedFile} />
                }
                setEntityData={setEntityData}
                path={Api.identity.user}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.identity.user.route}
            />
        </>
    );
}

export default UserNew;
